import { ExtendedAddress } from '@porterin/booking-flow/src/order-review/domain/entities/ExtendedAddress';
import { LatLng } from '@porterin/booking-flow/src/order-review/domain/entities/LatLng';
import { getExtendedAddressFromLatLng } from '@porterin/booking-flow/src/order-review/view/helpers/GeoCodeHelper';
import { useLocation } from '@porterin/component-library/src/location-accuracy//contexts/LocationContext';
import { CONFIG, selectLocationIcon } from '@porterin/component-library/src/location-accuracy/store/LocationAccuracyStore';
import { handleGeolocationError } from '@porterin/component-library/src/location-accuracy/utils/LocationAccuracyHelpers';
import Image from 'next/image';
import React, { useState } from 'react';

export interface MapAutoDetectLocationProps {
  is_dragging: boolean;
  set_center: (value: React.SetStateAction<LatLng>) => void;
}

export const MapAutoDetectLocationCmp: React.FC<MapAutoDetectLocationProps> = ({
  is_dragging,
  set_center,
}) => {
  const { selectLocation } = useLocation();
  const [error, setError] = useState<string | null>(null);
  const handleGetLocation = () => {
    if (!navigator.geolocation) {
      setError('Geolocation is not supported by your browser.');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async position => {
        const { latitude, longitude } = position.coords;
        const latLng = {
          lat: latitude,
          lng: longitude,
        };

        try {
          const result: ExtendedAddress =
            await getExtendedAddressFromLatLng(latLng);
  
          selectLocation(result);
          set_center(latLng);
          setError(null);
        } catch (error) {
          setError('Failed to fetch address from location');
        }
      },
      err => {
        handleGeolocationError(err, setError);
      },
      {
        maximumAge: CONFIG.locationAccuracyMaxAge,
      }
    );
  };

  if (is_dragging) {
    return null;
  }

  return (
    <div
      data-testid="select-location-overlay"
      id="select-location-overlay"
      className="absolute right-[1rem] bottom-[26rem] z-10"
    >
      <button
        className="flex items-center justify-center bg-white rounded-full p-2 shadow-md"
        onClick={handleGetLocation}
        data-testid="get-location-btn"
      >
        <Image
          src={selectLocationIcon}
          alt="Select Location"
          width={20}
          height={20}
        />
      </button>
    </div>
  );
};
